<div id="container">
  <h3>Import Atlas Files</h3>
  This is a manual alternative to update Atlas information
  <div class="ui list">
    <div class="item">
      - Download all the files for the day from this
      <a target="_blank" href="https://mft.us.kpmg.com/">link</a>. The files
      downloaded contain all Atlas data.
    </div>
    <div class="item">
      - Uploading will replace all the curernt Atlas data. This feature does not
      "Append" the data.
    </div>
    <div class="item">
      - Upload all the files below by selecting ALL the files. DO NOT upload one
      at a time because of the reasons stated above.
    </div>
  </div>

  <div class="buttons">
    <div>
      <div class="flex-grow"></div>
      <div>
        <div id="file-upload">
          <input
            type="file"
            #configFileUpload
            id="config-upload-btn"
            (change)="initFile($event.target.files)"
            multiple
          />
        </div>
      </div>
    </div>

    <div>
      <div class="flex-grow"></div>

      <div>
        <div
          (click)="upload()"
          id="upload-btn"
          class="ui primary background button"
          [ngClass]="{ loading: isLoading, disabled: !configFile }"
        >
          Upload
        </div>
      </div>
    </div>
  </div>

  <div #modal class="ui tiny modal" id="config-modal">
    <div class="icon modal-close close"></div>
    <div
      class="icon"
      [ngClass]="{
        'green-success': modalMessage?.success,
        'red-error': modalMessage?.error
      }"
    ></div>

    <div class="content">
      <h3>
        {{ modalMessage?.error && "Incorrect file setup" }}
      </h3>

      <h3>
        {{
          modalMessage?.success && "Atlas Files have been successfuly imported"
        }}
      </h3>

      @if (modalMessage?.error) {
      <p>{{ modalMessage?.error?.message }}</p>
      } @if (modalMessage?.success) {
      <div>
        @for (table of modalMessage?.success?.message; track table) {
        <p>{{ table }}</p>
        }
      </div>
      }
    </div>

    <div class="actions">
      <div class="ui primary background button approve">OK</div>
    </div>
  </div>
</div>
